import React, { FC } from 'react'
import CoinList from './components/CoinList'
import Overview from './components/Overview'
import { WalletItemModel } from '@/services/apis/wallet/models'

interface AssetWalletDetailProps {
  wallet: WalletItemModel
  isLoading: boolean
}

const AssetWalletDetail: FC<AssetWalletDetailProps> = ({ wallet, isLoading }) => {
  return (
    <>
      <Overview data={wallet} />
      <CoinList data={wallet} isLoading={isLoading} />
    </>
  )
}

export default React.memo(AssetWalletDetail)
